import type { LanguageCode } from '../types';

type Translation = Record<string, string>;

export const languages: Array<{ code: LanguageCode; label: string; nativeName: string }> = [
  { code: 'ru', label: 'Russian', nativeName: 'Русский' },
  { code: 'en', label: 'English', nativeName: 'English' },
  { code: 'de', label: 'German', nativeName: 'Deutsch' },
  { code: 'el', label: 'Greek', nativeName: 'Ελληνικά' },
  { code: 'es', label: 'Spanish', nativeName: 'Español' },
  { code: 'fr', label: 'French', nativeName: 'Français' },
];

export const dictionary: Record<LanguageCode, Translation> = {
  ru: {
    appName: 'Kim Converter',
    navPrivacy: 'Конфиденциальность',
    seoFormatsEyebrow: 'Форматы и приватность',
    seoFormatsTitle: 'Конвертация файлов без загрузки на сервер',
    seoFormatsText:
      'Kim Converter подходит для быстрых задач: подготовить изображение для сайта, изменить разрешение фото, обрезать кадр, перевести таблицу JSON в CSV или сжать файл в ZIP.',
    seoFormatsImage: 'Изображения: PNG, JPEG, AVIF, WebP и базовое редактирование размера или кадра.',
    seoFormatsFiles: 'Файлы: пакетная конвертация изображений, JSON в CSV, CSV в JSON и упаковка в ZIP.',
    seoFormatsPrivacy: 'Файлы обрабатываются локально в браузере; выбранные файлы не отправляются на сервер Kim Converter.',
    popularConvertersEyebrow: 'Популярные конвертеры',
    popularConvertersTitle: 'Конвертация файлов в нужный формат',
    popularConvertersText: 'Перетащите документ, аудио, видео, таблицу или архив: сайт откроет страницу конвертации и подберет доступные форматы.',
    privacyEyebrow: 'Данные и согласие',
    privacyTitle: 'Политика конфиденциальности',
    privacyIntro:
      'Kim Converter создан как браузерный инструмент: основная обработка файлов выполняется на вашем устройстве. Эта страница описывает, какие данные нужны сайту сейчас и как будут подключаться аналитика и реклама.',
    privacyFilesTitle: 'Файлы и изображения',
    privacyFilesText:
      'Загруженные в интерфейс файлы используются для обработки внутри браузера. Сайт не отправляет выбранные файлы на сервер Kim Converter для конвертации, хранения или ручной проверки.',
    privacyStorageTitle: 'Настройки сайта',
    privacyStorageText:
      'Сайт запоминает базовые настройки, чтобы интерфейс работал удобно.',
    privacyAdsTitle: 'Аналитика и реклама',
    privacyAdsText:
      'Аналитика помогает улучшать сайт. Реклама используется только при вашем разрешении.',
    privacyControlTitle: 'Управление согласием',
    privacyControlText:
      'Вы можете изменить выбор на этой странице. После сохранения обновите страницу, чтобы изменения применились.',
    consentTitle: 'Файлы cookie и конфиденциальность',
    consentText:
      'Мы используем необходимые настройки для работы сайта. Дополнительные категории можно разрешить или отключить отдельно.',
    consentAccept: 'Принять все',
    consentReject: 'Только необходимое',
    consentSettings: 'Настроить',
    consentBack: 'Назад',
    consentSave: 'Сохранить выбор',
    consentSaveNotice: 'Изменения приняты. Они вступят в силу после обновления страницы.',
    consentNecessaryTitle: 'Необходимые',
    consentNecessaryText: 'Нужны для работы сайта и сохранения вашего выбора. Эту категорию нельзя отключить.',
    consentAnalyticsTitle: 'Аналитика',
    consentAnalyticsText: 'Помогает понять, какие разделы и функции используются чаще и где возникают ошибки.',
    consentAdvertisingTitle: 'Реклама',
    consentAdvertisingText: 'Нужна для показа рекламы и оценки ее работы, если реклама подключена.',
    navTools: 'Инструменты',
    navSeo: 'Преимущества',
    heroTitle: 'Конвертируйте файлы и редактируйте изображения онлайн',
    heroText:
      'Редактируйте изображения, меняйте размер, обрезайте кадр и конвертируйте файлы прямо в браузере. Бесплатно, без водяных знаков, лимитов и скрытых ограничений.',
    heroCta: 'Выбрать категорию',
    startWork: 'Начать работу',
    heroSecondaryCta: 'Почему бесплатно',
    heroPrivacy: 'Локальная обработка в браузере',
    taskChoiceEyebrow: 'Выберите задачу',
    taskChoiceTitle: 'Что нужно сделать с файлом',
    taskChoiceText: 'Загрузите файл в нужный столбик или откройте отдельную страницу инструмента. После загрузки сайт сразу перенесет файл в подходящий рабочий раздел.',
    fileTaskBadge: 'Конвертация',
    imageTaskBadge: 'Редактирование',
    fileInfoTitle: 'Конвертация файлов без лишних шагов',
    fileInfoText: 'Загрузите файл, выберите подходящий формат и скачайте результат. Конвертер подходит для изображений, таблиц, документов, аудио, видео и ZIP-архивов.',
    fileInfoCta: 'Открыть конвертер',
    fileInfoDetailsEyebrow: 'Только конвертация',
    fileInfoDetailsTitle: 'Форматы собраны в одном рабочем процессе',
    fileInfoDetailsText: 'Страница конвертации показывает только задачи с файлами: выбор формата, пакетная обработка, оценка размера и скачивание результата.',
    fileInfoPointOne: 'Поддержка изображений, аудио, видео, документов, JSON, CSV и ZIP.',
    fileInfoPointTwo: 'Формат можно выбрать для каждого файла отдельно или применить общий формат к группе.',
    fileInfoPointThree: 'Браузерная обработка используется там, где это возможно; сложные форматы отправляются на серверный конвертер.',
    imageInfoTitle: 'Редактирование изображений в браузере',
    imageInfoText: 'Загрузите изображение, измените размер, обрежьте кадр, сохраните пропорции и экспортируйте готовый файл в PNG, JPEG, PNG или AVIF.',
    imageInfoCta: 'Открыть редактор',
    imageInfoDetailsEyebrow: 'Только изображения',
    imageInfoDetailsTitle: 'Инструменты редактора не смешаны с конвертером файлов',
    imageInfoDetailsText: 'Страница редактирования показывает только работу с картинками: предпросмотр, кадрирование, размеры, качество и экспорт.',
    imageInfoPointOne: 'Обрезка изображения с готовыми соотношениями сторон и свободным кадром.',
    imageInfoPointTwo: 'Изменение ширины и высоты с сохранением пропорций.',
    imageInfoPointThree: 'Экспорт в PNG, JPEG, PNG или AVIF без водяных знаков.',
    conversionInput: 'Исходный файл',
    conversionOutput: 'Результат',
    conversionPrevious: 'Показать предыдущую пару форматов',
    conversionNext: 'Показать следующую пару форматов',
    conversionOpen: 'Открыть страницу конвертации этой пары форматов',
    imageTool: 'Редактирование изображений',
    fileTool: 'Конвертация файлов',
    language: 'Язык',
    categoryTitle: 'Загрузите фото для редактирования',
    categoryText:
      'Перетащите фотографию, выберите ее с устройства или вставьте URL. Изображение откроется в редакторе для обрезки, изменения размера и экспорта.',
    homeImageUploadTitle: 'Перетащите фото для редактирования',
    homeImageUploadText: 'PNG, JPG, AVIF, WebP, BMP, GIF или SVG',
    homeConverterUploadTitle: 'Перетащите файл для конвертации',
    homeConverterUploadText: 'Изображения, аудио, видео, документы, таблицы и архивы',
    homeUploadTitle: 'Перетащите файл сюда',
    homeUploadText: 'Изображения, аудио, видео, документы, таблицы и архивы',
    homeUploadUrlPlaceholder: 'Вставьте URL файла',
    homeUploadUrlButton: 'Открыть URL',
    homeUploadUrlError: 'Не удалось загрузить файл по URL. Проверьте ссылку или выберите файл с устройства.',
    imageCategoryTitle: 'Редактирование изображений',
    imageCategoryText:
      'Меняйте размеры, сохраняйте пропорции, выбирайте соотношение сторон, обрезайте изображение и экспортируйте результат в PNG, JPEG, PNG или AVIF.',
    fileCategoryTitle: 'Конвертация файлов',
    fileCategoryText:
      'Переводите файлы из одного формата в другой: изображения, таблицы, JSON, CSV, ZIP и другие форматы по мере расширения сервиса.',
    openCategory: 'Открыть страницу',
    backToCategories: 'К категориям',
    imagePageTitle: 'Редактирование изображений',
    imagePageText: 'Загрузите изображение, задайте обрезку, размер, формат и качество. Результат можно скачать без водяного знака.',
    filePageTitle: 'Конвертация файлов',
    filePageText: 'Выберите профиль конвертации, загрузите файл и получите готовый результат без очередей и ограничений.',
    freeTitle: 'Бесплатно для всех задач',
    freeText: 'Редактирование изображений и конвертация файлов доступны без подписки, пробных периодов и платных экспортов.',
    watermarkTitle: 'Без водяных знаков',
    watermarkText: 'Скачиваемые файлы остаются вашими: сервис не добавляет логотипы, подписи или рекламные метки.',
    unlimitedTitle: 'Безлимитная обработка',
    unlimitedText: 'Можно обрабатывать столько файлов, сколько нужно. Лимитов по количеству операций внутри интерфейса нет.',
    uploadImage: 'Загрузите изображение',
    uploadFile: 'Загрузите файл',
    uploadFiles: 'Загрузите файлы',
    dropImage: 'PNG, JPEG, WebP, AVIF или BMP',
    chooseFile: 'Выбрать файл',
    resize: 'Размер',
    crop: 'Обрезка',
    format: 'Формат',
    quality: 'Качество',
    width: 'Ширина',
    height: 'Высота',
    keepRatio: 'Сохранять пропорции',
    preset: 'Соотношение',
    process: 'Обработать',
    download: 'Скачать',
    convertedReady: 'Файл готов',
    conversionType: 'Тип конвертации',
    selectedFilesCount: 'Выбрано файлов: {count}',
    clearFiles: 'Очистить список',
    convertedFilesReady: 'Готово файлов: {count}',
    downloadAll: 'Скачать все ZIP',
    fileUploadHint: 'Изображения, аудио, видео, документы, таблицы и архивы',
    applyFormatToAll: 'Формат для всех файлов',
    formatsByCategory: 'Форматы по категориям',
    fileFormat: 'Формат файла',
    formatSearch: 'Поиск формата',
    formatSearchPlaceholder: 'Например: webp, pdf, mp3',
    noFormatsFound: 'Форматы не найдены',
    chooseFormatAfterUpload: 'Сначала загрузите файлы',
    chooseFormatAfterUploadText: 'После загрузки возле каждого файла появится поиск и выбор формата конвертации.',
    chooseFormat: 'Выберите формат',
    conversionQueue: 'Очередь',
    selectedFilesTitle: 'Файлы для конвертации',
    selectedFilesText: 'Настройте формат и сжатие перед запуском конвертации.',
    estimatedSize: 'Примерный размер',
    estimatedTotalSize: 'Примерно после обработки',
    batchActions: 'Пакетная обработка',
    batchActionsText: 'Примените общий формат, если все выбранные файлы одного типа, или настройте файлы отдельно.',
    noCommonFormats: 'У выбранных файлов нет общего набора форматов. Настройте формат в каждой карточке файла.',
    serverRequiredSelection: 'Один или несколько выбранных форматов будут обработаны на сервере через бесплатные движки LibreOffice, Ghostscript или ImageMagick.',
    removeFile: 'Удалить файл',
    compressionSettings: 'Сжатие',
    compressionLevel: 'Сжатие {value}%',
    compressionHint: 'Больше сжатие — меньше размер файла, но ниже качество для изображений, аудио, видео и GIF.',
    conversionProgress: 'Прогресс конвертации',
    conversionProgressCurrent: 'Сейчас: {file}',
    conversionProgressDone: 'Конвертация завершена',
    serverRequiredShort: 'нужен сервер',
    serverRequiredDesc: 'Конвертация на сервере через бесплатные движки LibreOffice, Ghostscript или ImageMagick.',
    'category.image': 'Изображения',
    'category.audio': 'Аудио',
    'category.video': 'Видео',
    'category.document': 'Документы',
    'category.data': 'Данные',
    'category.archive': 'Архивы',
    imageToWebp: 'Изображения в WebP',
    imageToWebpDesc: 'Пакетная конвертация изображений в WebP',
    imageToJpeg: 'Изображения в JPEG',
    imageToJpegDesc: 'Пакетная конвертация изображений в JPEG',
    imageToJpg: 'Изображения в JPG',
    imageToJpgDesc: 'Пакетная конвертация изображений в JPG',
    imageToPng: 'Изображения в PNG',
    imageToPngDesc: 'Пакетная конвертация изображений в PNG',
    imageToAvif: 'Изображения в AVIF',
    imageToAvifDesc: 'Пакетная конвертация изображений в AVIF',
    imageToBmp: 'Изображения в BMP',
    imageToBmpDesc: 'Конвертация изображений в BMP через FFmpeg WebAssembly',
    imageToGif: 'Изображения в GIF',
    imageToGifDesc: 'Конвертация изображений в GIF через FFmpeg WebAssembly',
    imageToIco: 'Изображения в ICO',
    imageToIcoDesc: 'Конвертация изображений в ICO через FFmpeg WebAssembly',
    imageToSvg: 'Изображения в SVG',
    imageToSvgDesc: 'SVG-файл с растровым изображением внутри',
    imageToTga: 'Изображения в TGA',
    imageToTgaDesc: 'Конвертация изображений в TGA через FFmpeg WebAssembly',
    imageToTiff: 'Изображения в TIFF',
    imageToTiffDesc: 'Конвертация изображений в TIFF через FFmpeg WebAssembly',
    imageToEps: 'Изображения в EPS',
    imageToPsd: 'Изображения в PSD',
    imageToOdd: 'Изображения в ODD',
    audioToMp3: 'Аудио в MP3',
    audioToMp3Desc: 'Конвертация аудио в MP3 192 kbps через FFmpeg WebAssembly',
    audioToWav: 'Аудио в WAV',
    audioToWavDesc: 'Конвертация аудио в WAV PCM',
    audioToOgg: 'Аудио в OGG',
    audioToOggDesc: 'Конвертация аудио в OGG Vorbis',
    audioToFlac: 'Аудио в FLAC',
    audioToFlacDesc: 'Конвертация аудио в FLAC',
    audioToAac: 'Аудио в AAC',
    audioToAacDesc: 'Конвертация аудио в AAC 192 kbps',
    audioToM4a: 'Аудио в M4A',
    audioToM4aDesc: 'Конвертация аудио в M4A/AAC',
    videoToMp4: 'Видео в MP4',
    videoToMp4Desc: 'Конвертация видео в MP4 через FFmpeg WebAssembly',
    videoToWebm: 'Видео в WebM',
    videoToWebmDesc: 'Конвертация видео в WebM через FFmpeg WebAssembly',
    videoToGif: 'Видео/GIF в GIF',
    videoToGifDesc: 'Создание GIF из видео или перекодирование GIF',
    docxToTxt: 'DOCX в TXT',
    docxToTxtDesc: 'Извлечение текста из DOCX локально в браузере',
    txtToPdf: 'TXT/TEXT в PDF',
    txtToPdfDesc: 'Создание простого PDF из текстового файла',
    txtToText: 'TXT в TEXT',
    txtToTextDesc: 'Смена текстового расширения без изменения содержимого',
    documentToDoc: 'Документы в DOC',
    documentToDocx: 'Документы в DOCX',
    documentToPs: 'Документы в PS',
    documentToWord: 'Документы в WORD',
    jsonToCsv: 'JSON в CSV',
    jsonToCsvDesc: 'Массив объектов в таблицу CSV',
    csvToJson: 'CSV в JSON',
    csvToJsonDesc: 'CSV-таблица в форматированный JSON',
    textToZip: 'Файл в ZIP',
    textToZipDesc: 'Сжатие любого выбранного файла в ZIP',
    seoTitle: 'Редактируйте и конвертируйте без ограничений',
    seoText:
      'Kim Converter помогает бесплатно подготавливать изображения, менять размер и формат, обрезать кадры, конвертировать таблицы, архивировать файлы и получать результат без water mark и без лимитов.',
    footerText:
      'Бесплатный браузерный сервис для редактирования изображений и пакетной конвертации файлов без водяных знаков.',
    light: 'Светлая',
    dark: 'Темная',
  },
  en: {
    appName: 'Kim Converter',
    navPrivacy: 'Privacy',
    seoFormatsEyebrow: 'Formats and privacy',
    seoFormatsTitle: 'File conversion without server upload',
    seoFormatsText:
      'Kim Converter is built for quick tasks: prepare an image for a website, resize a photo, crop a frame, convert JSON tables to CSV or compress a file to ZIP.',
    seoFormatsImage: 'Images: PNG, JPEG, AVIF, WebP and basic size or crop editing.',
    seoFormatsFiles: 'Files: batch image conversion, JSON to CSV, CSV to JSON and ZIP packaging.',
    seoFormatsPrivacy: 'Files are processed locally in the browser; selected files are not uploaded to Kim Converter servers.',
    popularConvertersEyebrow: 'Popular converters',
    popularConvertersTitle: 'Convert files to the format you need',
    popularConvertersText: 'Drop a document, audio, video, spreadsheet or archive and the site will open the converter with available formats.',
    privacyEyebrow: 'Data and consent',
    privacyTitle: 'Privacy Policy',
    privacyIntro:
      'Kim Converter is a browser-based tool: the main file processing happens on your device. This page explains what data the site needs now and how analytics and advertising will be enabled.',
    privacyFilesTitle: 'Files and images',
    privacyFilesText:
      'Files selected in the interface are used for processing inside the browser. The site does not upload selected files to Kim Converter servers for conversion, storage or manual review.',
    privacyStorageTitle: 'Site settings',
    privacyStorageText:
      'The site remembers basic settings so the interface works comfortably.',
    privacyAdsTitle: 'Analytics and advertising',
    privacyAdsText:
      'Analytics helps improve the site. Advertising is used only with your permission.',
    privacyControlTitle: 'Consent control',
    privacyControlText:
      'You can change your choice on this page. After saving, refresh the page to apply changes.',
    consentTitle: 'Cookies and privacy',
    consentText:
      'We use required settings to keep the site working. Optional categories can be allowed or disabled separately.',
    consentAccept: 'Accept all',
    consentReject: 'Required only',
    consentSettings: 'Settings',
    consentBack: 'Back',
    consentSave: 'Save choice',
    consentSaveNotice: 'Your choice has been saved. Changes will take effect after refreshing the page.',
    consentNecessaryTitle: 'Required',
    consentNecessaryText: 'Needed for the site to work and to save your choice. This category cannot be disabled.',
    consentAnalyticsTitle: 'Analytics',
    consentAnalyticsText: 'Helps understand which sections and features are used more often and where errors happen.',
    consentAdvertisingTitle: 'Advertising',
    consentAdvertisingText: 'Needed to show ads and evaluate their performance if advertising is connected.',
    navTools: 'Tools',
    navSeo: 'Benefits',
    heroTitle: 'Convert files and edit images online',
    heroText:
      'Edit images, resize, crop and convert files directly in your browser. Free, watermark-free, unlimited and without hidden restrictions.',
    heroCta: 'Choose category',
    startWork: 'Start working',
    heroSecondaryCta: 'Why it is free',
    heroPrivacy: 'Local browser processing',
    taskChoiceEyebrow: 'Choose a task',
    taskChoiceTitle: 'What do you need to do with a file',
    taskChoiceText: 'Upload a file in the matching column or open the dedicated tool page. After upload, the site sends the file to the right workspace.',
    fileTaskBadge: 'Conversion',
    imageTaskBadge: 'Editing',
    fileInfoTitle: 'File conversion without extra steps',
    fileInfoText: 'Upload a file, choose the right format and download the result. The converter works with images, tables, documents, audio, video and ZIP archives.',
    fileInfoCta: 'Open converter',
    fileInfoDetailsEyebrow: 'Conversion only',
    fileInfoDetailsTitle: 'Formats are grouped in one workflow',
    fileInfoDetailsText: 'The conversion page focuses on file tasks only: format selection, batch processing, estimated size and result download.',
    fileInfoPointOne: 'Supports images, audio, video, documents, JSON, CSV and ZIP.',
    fileInfoPointTwo: 'Choose a format for each file or apply one format to a compatible group.',
    fileInfoPointThree: 'Browser processing is used when possible; complex formats go through the server converter.',
    imageInfoTitle: 'Image editing in the browser',
    imageInfoText: 'Upload an image, resize it, crop the frame, keep proportions and export the final file as PNG, JPEG, AVIF or WebP.',
    imageInfoCta: 'Open editor',
    imageInfoDetailsEyebrow: 'Images only',
    imageInfoDetailsTitle: 'Editor tools are separated from file conversion',
    imageInfoDetailsText: 'The image editing page focuses on pictures only: preview, crop, dimensions, quality and export.',
    imageInfoPointOne: 'Crop with ready-made aspect ratios or a free frame.',
    imageInfoPointTwo: 'Change width and height while keeping proportions.',
    imageInfoPointThree: 'Export to PNG, JPEG, AVIF or WebP without watermarks.',
    conversionInput: 'Input',
    conversionOutput: 'Output',
    conversionPrevious: 'Show previous format pair',
    conversionNext: 'Show next format pair',
    conversionOpen: 'Open this format conversion page',
    imageTool: 'Image editing',
    fileTool: 'File conversion',
    language: 'Language',
    categoryTitle: 'Upload a photo for editing',
    categoryText: 'Drop a photo, choose it from your device or paste a URL. The image opens in the editor for crop, resize and export.',
    homeImageUploadTitle: 'Drop a photo to edit',
    homeImageUploadText: 'PNG, JPG, AVIF, WebP, BMP, GIF or SVG',
    homeConverterUploadTitle: 'Drop a file to convert',
    homeConverterUploadText: 'Images, audio, video, documents, tables and archives',
    homeUploadTitle: 'Drop a file here',
    homeUploadText: 'Images, audio, video, documents, tables and archives',
    homeUploadUrlPlaceholder: 'Paste a file URL',
    homeUploadUrlButton: 'Open URL',
    homeUploadUrlError: 'Could not load the file from this URL. Check the link or choose a local file.',
    imageCategoryTitle: 'Image editing',
    imageCategoryText:
      'Resize images, keep proportions, choose an aspect ratio, crop the frame and export to PNG, JPEG, AVIF or WebP.',
    fileCategoryTitle: 'File conversion',
    fileCategoryText:
      'Convert files from one format to another: images, tables, JSON, CSV, ZIP and more formats as the service grows.',
    openCategory: 'Open page',
    backToCategories: 'Back to categories',
    imagePageTitle: 'Image editing',
    imagePageText: 'Upload an image, set crop, size, format and quality. Download the result without a watermark.',
    filePageTitle: 'File conversion',
    filePageText: 'Choose a conversion profile, upload a file and get the finished result without queues or limits.',
    freeTitle: 'Free for every task',
    freeText: 'Image editing and file conversion are available without subscriptions, trials or paid exports.',
    watermarkTitle: 'No watermarks',
    watermarkText: 'Downloaded files stay yours: no logos, signatures or advertising marks are added.',
    unlimitedTitle: 'Unlimited processing',
    unlimitedText: 'Process as many files as you need. There are no operation limits inside the interface.',
    uploadImage: 'Upload an image',
    uploadFile: 'Upload a file',
    uploadFiles: 'Upload files',
    dropImage: 'PNG, JPEG, WebP, AVIF or BMP',
    chooseFile: 'Choose file',
    resize: 'Resize',
    crop: 'Crop',
    format: 'Format',
    quality: 'Quality',
    width: 'Width',
    height: 'Height',
    keepRatio: 'Keep ratio',
    preset: 'Aspect',
    process: 'Process',
    download: 'Download',
    convertedReady: 'File ready',
    conversionType: 'Conversion type',
    selectedFilesCount: 'Selected files: {count}',
    clearFiles: 'Clear list',
    convertedFilesReady: 'Ready files: {count}',
    downloadAll: 'Download ZIP',
    fileUploadHint: 'Images, audio, video, documents, tables and archives',
    applyFormatToAll: 'Format for all files',
    formatsByCategory: 'Formats by category',
    fileFormat: 'File format',
    formatSearch: 'Search format',
    formatSearchPlaceholder: 'For example: webp, pdf, mp3',
    noFormatsFound: 'No formats found',
    chooseFormatAfterUpload: 'Upload files first',
    chooseFormatAfterUploadText: 'After upload, each file gets its own searchable conversion format selector.',
    chooseFormat: 'Choose format',
    conversionQueue: 'Queue',
    selectedFilesTitle: 'Files to convert',
    selectedFilesText: 'Set the format and compression before starting conversion.',
    estimatedSize: 'Estimated size',
    estimatedTotalSize: 'Estimated after processing',
    batchActions: 'Batch actions',
    batchActionsText: 'Apply one format when all selected files have the same type, or configure each file separately.',
    noCommonFormats: 'The selected files do not share one common format set. Configure each file card separately.',
    serverRequiredSelection: 'One or more selected formats will be processed on the server with free LibreOffice, Ghostscript or ImageMagick engines.',
    removeFile: 'Remove file',
    compressionSettings: 'Compression',
    compressionLevel: 'Compression {value}%',
    compressionHint: 'Higher compression makes smaller files, with lower quality for images, audio, video and GIF.',
    conversionProgress: 'Conversion progress',
    conversionProgressCurrent: 'Now: {file}',
    conversionProgressDone: 'Conversion complete',
    serverRequiredShort: 'server required',
    serverRequiredDesc: 'Server conversion with free LibreOffice, Ghostscript or ImageMagick engines.',
    'category.image': 'Images',
    'category.audio': 'Audio',
    'category.video': 'Video',
    'category.document': 'Documents',
    'category.data': 'Data',
    'category.archive': 'Archives',
    imageToWebp: 'Images to WebP',
    imageToWebpDesc: 'Batch image conversion to WebP',
    imageToJpeg: 'Images to JPEG',
    imageToJpegDesc: 'Batch image conversion to JPEG',
    imageToJpg: 'Images to JPG',
    imageToJpgDesc: 'Batch image conversion to JPG',
    imageToPng: 'Images to PNG',
    imageToPngDesc: 'Batch image conversion to PNG',
    imageToAvif: 'Images to AVIF',
    imageToAvifDesc: 'Batch image conversion to AVIF',
    imageToBmp: 'Images to BMP',
    imageToBmpDesc: 'Convert images to BMP with FFmpeg WebAssembly',
    imageToGif: 'Images to GIF',
    imageToGifDesc: 'Convert images to GIF with FFmpeg WebAssembly',
    imageToIco: 'Images to ICO',
    imageToIcoDesc: 'Convert images to ICO with FFmpeg WebAssembly',
    imageToSvg: 'Images to SVG',
    imageToSvgDesc: 'Creates an SVG file with the raster image embedded',
    imageToTga: 'Images to TGA',
    imageToTgaDesc: 'Convert images to TGA with FFmpeg WebAssembly',
    imageToTiff: 'Images to TIFF',
    imageToTiffDesc: 'Convert images to TIFF with FFmpeg WebAssembly',
    imageToEps: 'Images to EPS',
    imageToPsd: 'Images to PSD',
    imageToOdd: 'Images to ODD',
    audioToMp3: 'Audio to MP3',
    audioToMp3Desc: 'Convert audio to 192 kbps MP3 with FFmpeg WebAssembly',
    audioToWav: 'Audio to WAV',
    audioToWavDesc: 'Convert audio to WAV PCM',
    audioToOgg: 'Audio to OGG',
    audioToOggDesc: 'Convert audio to OGG Vorbis',
    audioToFlac: 'Audio to FLAC',
    audioToFlacDesc: 'Convert audio to FLAC',
    audioToAac: 'Audio to AAC',
    audioToAacDesc: 'Convert audio to 192 kbps AAC',
    audioToM4a: 'Audio to M4A',
    audioToM4aDesc: 'Convert audio to M4A/AAC',
    videoToMp4: 'Video to MP4',
    videoToMp4Desc: 'Convert video to MP4 with FFmpeg WebAssembly',
    videoToWebm: 'Video to WebM',
    videoToWebmDesc: 'Convert video to WebM with FFmpeg WebAssembly',
    videoToGif: 'Video/GIF to GIF',
    videoToGifDesc: 'Create a GIF from video or re-encode a GIF',
    docxToTxt: 'DOCX to TXT',
    docxToTxtDesc: 'Extract DOCX text locally in the browser',
    txtToPdf: 'TXT/TEXT to PDF',
    txtToPdfDesc: 'Create a simple PDF from a text file',
    txtToText: 'TXT to TEXT',
    txtToTextDesc: 'Change the text extension without changing content',
    documentToDoc: 'Documents to DOC',
    documentToDocx: 'Documents to DOCX',
    documentToPs: 'Documents to PS',
    documentToWord: 'Documents to WORD',
    jsonToCsv: 'JSON to CSV',
    jsonToCsvDesc: 'Array of objects to comma-separated table',
    csvToJson: 'CSV to JSON',
    csvToJsonDesc: 'CSV table to formatted JSON',
    textToZip: 'File to ZIP',
    textToZipDesc: 'Compress any selected file into ZIP',
    seoTitle: 'Edit and convert without limits',
    seoText:
      'Kim Converter helps prepare images, change size and format, crop frames, convert tables, archive files and get the result for free, without watermarks or limits.',
    footerText:
      'A free browser service for image editing and batch file conversion without watermarks.',
    light: 'Light',
    dark: 'Dark',
  },
  de: {
    appName: 'Kim Converter',
    navTools: 'Werkzeuge',
    navSeo: 'Funktionen',
    heroTitle: 'Schneller Bild- und Dateikonverter',
    heroText: 'Bilder skalieren, zuschneiden und Dateien direkt im Browser konvertieren.',
    heroCta: 'Konvertieren',
    heroPrivacy: 'Kein Server-Upload',
    imageTool: 'Bilder',
    fileTool: 'Dateien',
    uploadImage: 'Bild hochladen',
    uploadFile: 'Datei hochladen',
    dropImage: 'PNG, JPEG, WebP, AVIF oder BMP',
    chooseFile: 'Datei wählen',
    resize: 'Größe',
    crop: 'Zuschneiden',
    format: 'Format',
    quality: 'Qualität',
    width: 'Breite',
    height: 'Höhe',
    keepRatio: 'Proportionen behalten',
    preset: 'Seitenverhältnis',
    process: 'Verarbeiten',
    download: 'Herunterladen',
    convertedReady: 'Datei bereit',
    conversionType: 'Konvertierung',
    jsonToCsv: 'JSON zu CSV',
    jsonToCsvDesc: 'Objektliste in eine CSV-Tabelle',
    csvToJson: 'CSV zu JSON',
    csvToJsonDesc: 'CSV-Tabelle in formatiertes JSON',
    textToZip: 'Datei zu ZIP',
    textToZipDesc: 'Ausgewählte Datei als ZIP komprimieren',
    navPrivacy: 'Datenschutz',
    seoFormatsEyebrow: 'Formate und Datenschutz',
    seoFormatsTitle: 'Dateikonvertierung ohne Server-Upload',
    seoFormatsText:
      'Kim Converter ist für schnelle Aufgaben gemacht: ein Bild für eine Website vorbereiten, ein Foto skalieren, einen Ausschnitt zuschneiden, JSON-Tabellen in CSV umwandeln oder eine Datei als ZIP komprimieren.',
    seoFormatsImage: 'Bilder: PNG, JPEG, AVIF, WebP sowie grundlegende Größen- und Zuschnittbearbeitung.',
    seoFormatsFiles: 'Dateien: Stapelkonvertierung von Bildern, JSON zu CSV, CSV zu JSON und ZIP-Pakete.',
    seoFormatsPrivacy: 'Dateien werden lokal im Browser verarbeitet; ausgewählte Dateien werden nicht an Kim Converter-Server gesendet.',
    popularConvertersEyebrow: 'Beliebte Konverter',
    popularConvertersTitle: 'Dateien ins gewünschte Format konvertieren',
    popularConvertersText: 'Legen Sie ein Dokument, Audio, Video, eine Tabelle oder ein Archiv ab; die Seite öffnet den Konverter mit passenden Formaten.',
    privacyEyebrow: 'Daten und Zustimmung',
    privacyTitle: 'Datenschutzerklärung',
    privacyIntro:
      'Kim Converter ist ein Browser-Werkzeug: die wichtigste Dateiverarbeitung findet auf Ihrem Gerät statt. Diese Seite erklärt, welche Daten die Website benötigt und wie Analyse und Werbung aktiviert werden.',
    privacyFilesTitle: 'Dateien und Bilder',
    privacyFilesText:
      'Im Interface ausgewählte Dateien werden für die Verarbeitung im Browser verwendet. Die Website lädt sie nicht zur Konvertierung, Speicherung oder manuellen Prüfung auf Kim Converter-Server hoch.',
    privacyStorageTitle: 'Website-Einstellungen',
    privacyStorageText:
      'Die Website merkt sich grundlegende Einstellungen, damit die Oberfläche komfortabel funktioniert.',
    privacyAdsTitle: 'Analyse und Werbung',
    privacyAdsText:
      'Analyse hilft, die Website zu verbessern. Werbung wird nur mit Ihrer Erlaubnis verwendet.',
    privacyControlTitle: 'Zustimmung verwalten',
    privacyControlText:
      'Sie können Ihre Auswahl auf dieser Seite ändern. Aktualisieren Sie die Seite nach dem Speichern, damit Änderungen wirksam werden.',
    consentTitle: 'Cookies und Datenschutz',
    consentText:
      'Wir verwenden erforderliche Einstellungen, damit die Website funktioniert. Optionale Kategorien können einzeln erlaubt oder deaktiviert werden.',
    consentAccept: 'Alle akzeptieren',
    consentReject: 'Nur erforderlich',
    consentSettings: 'Einstellungen',
    consentBack: 'Zurück',
    consentSave: 'Auswahl speichern',
    consentSaveNotice: 'Ihre Auswahl wurde gespeichert. Änderungen werden nach dem Aktualisieren der Seite wirksam.',
    consentNecessaryTitle: 'Erforderlich',
    consentNecessaryText: 'Notwendig für den Betrieb der Website und zum Speichern Ihrer Auswahl. Diese Kategorie kann nicht deaktiviert werden.',
    consentAnalyticsTitle: 'Analyse',
    consentAnalyticsText: 'Hilft zu verstehen, welche Bereiche und Funktionen häufiger genutzt werden und wo Fehler auftreten.',
    consentAdvertisingTitle: 'Werbung',
    consentAdvertisingText: 'Wird benötigt, um Werbung anzuzeigen und ihre Leistung zu bewerten, falls Werbung verbunden ist.',
    startWork: 'Arbeit starten',
    heroSecondaryCta: 'Warum kostenlos',
    taskChoiceEyebrow: 'Aufgabe wählen',
    taskChoiceTitle: 'Was möchten Sie mit der Datei tun?',
    taskChoiceText: 'Laden Sie eine Datei in die passende Spalte hoch oder öffnen Sie die eigene Werkzeugseite. Nach dem Upload landet die Datei direkt im richtigen Arbeitsbereich.',
    fileTaskBadge: 'Konvertierung',
    imageTaskBadge: 'Bearbeitung',
    fileInfoTitle: 'Dateikonvertierung ohne zusätzliche Schritte',
    fileInfoText: 'Laden Sie eine Datei hoch, wählen Sie das passende Format und laden Sie das Ergebnis herunter. Der Konverter eignet sich für Bilder, Tabellen, Dokumente, Audio, Video und ZIP-Archive.',
    fileInfoCta: 'Konverter öffnen',
    fileInfoDetailsEyebrow: 'Nur Konvertierung',
    fileInfoDetailsTitle: 'Formate in einem Arbeitsablauf',
    fileInfoDetailsText: 'Die Konvertierungsseite konzentriert sich auf Dateiaufgaben: Formatauswahl, Stapelverarbeitung, Größenschätzung und Download.',
    fileInfoPointOne: 'Unterstützt Bilder, Audio, Video, Dokumente, JSON, CSV und ZIP.',
    fileInfoPointTwo: 'Wählen Sie ein Format pro Datei oder wenden Sie ein gemeinsames Format auf eine Gruppe an.',
    fileInfoPointThree: 'Browser-Verarbeitung wird genutzt, wenn möglich; komplexe Formate laufen über den Server-Konverter.',
    imageInfoTitle: 'Bildbearbeitung im Browser',
    imageInfoText: 'Laden Sie ein Bild hoch, ändern Sie die Größe, schneiden Sie den Ausschnitt zu, behalten Sie Proportionen und exportieren Sie als PNG, JPEG, AVIF oder WebP.',
    imageInfoCta: 'Editor öffnen',
    imageInfoDetailsEyebrow: 'Nur Bilder',
    imageInfoDetailsTitle: 'Editor-Werkzeuge sind von der Dateikonvertierung getrennt',
    imageInfoDetailsText: 'Die Bildbearbeitungsseite konzentriert sich auf Bilder: Vorschau, Zuschnitt, Abmessungen, Qualität und Export.',
    imageInfoPointOne: 'Zuschneiden mit fertigen Seitenverhältnissen oder freiem Rahmen.',
    imageInfoPointTwo: 'Breite und Höhe ändern und Proportionen behalten.',
    imageInfoPointThree: 'Export zu PNG, JPEG, AVIF oder WebP ohne Wasserzeichen.',
    conversionInput: 'Quelle',
    conversionOutput: 'Ergebnis',
    conversionPrevious: 'Vorheriges Formatpaar anzeigen',
    conversionNext: 'Nächstes Formatpaar anzeigen',
    conversionOpen: 'Seite für dieses Formatpaar öffnen',
    language: 'Sprache',
    categoryTitle: 'Foto zur Bearbeitung hochladen',
    categoryText: 'Ziehen Sie ein Foto hierher, wählen Sie es vom Gerät aus oder fügen Sie eine URL ein. Das Bild öffnet sich im Editor zum Zuschneiden, Skalieren und Exportieren.',
    homeImageUploadTitle: 'Foto zum Bearbeiten ablegen',
    homeImageUploadText: 'PNG, JPG, AVIF, WebP, BMP, GIF oder SVG',
    homeConverterUploadTitle: 'Datei zum Konvertieren ablegen',
    homeConverterUploadText: 'Bilder, Audio, Video, Dokumente, Tabellen und Archive',
    homeUploadTitle: 'Datei hier ablegen',
    homeUploadText: 'Bilder, Audio, Video, Dokumente, Tabellen und Archive',
    homeUploadUrlPlaceholder: 'Datei-URL einfügen',
    homeUploadUrlButton: 'URL öffnen',
    homeUploadUrlError: 'Die Datei konnte über diese URL nicht geladen werden. Prüfen Sie den Link oder wählen Sie eine lokale Datei.',
    imageCategoryTitle: 'Bildbearbeitung',
    imageCategoryText: 'Bilder skalieren, Proportionen behalten, Seitenverhältnis wählen, zuschneiden und nach PNG, JPEG, AVIF oder WebP exportieren.',
    fileCategoryTitle: 'Dateikonvertierung',
    fileCategoryText: 'Dateien von einem Format in ein anderes konvertieren: Bilder, Tabellen, JSON, CSV, ZIP und weitere Formate.',
    openCategory: 'Seite öffnen',
    backToCategories: 'Zurück zu den Kategorien',
    imagePageTitle: 'Bildbearbeitung',
    imagePageText: 'Laden Sie ein Bild hoch, legen Sie Zuschnitt, Größe, Format und Qualität fest und laden Sie das Ergebnis ohne Wasserzeichen herunter.',
    filePageTitle: 'Dateikonvertierung',
    filePageText: 'Wählen Sie ein Konvertierungsprofil, laden Sie eine Datei hoch und erhalten Sie das Ergebnis ohne Warteschlangen oder Limits.',
    freeTitle: 'Kostenlos für jede Aufgabe',
    freeText: 'Bildbearbeitung und Dateikonvertierung funktionieren ohne Abonnements, Testphasen oder bezahlte Exporte.',
    watermarkTitle: 'Keine Wasserzeichen',
    watermarkText: 'Heruntergeladene Dateien bleiben Ihre Dateien: keine Logos, Signaturen oder Werbemarken werden hinzugefügt.',
    unlimitedTitle: 'Unbegrenzte Verarbeitung',
    unlimitedText: 'Verarbeiten Sie so viele Dateien wie nötig. Innerhalb der Oberfläche gibt es keine Vorgangslimits.',
    uploadFiles: 'Dateien hochladen',
    selectedFilesCount: 'Ausgewählte Dateien: {count}',
    clearFiles: 'Liste leeren',
    convertedFilesReady: 'Fertige Dateien: {count}',
    downloadAll: 'ZIP herunterladen',
    fileUploadHint: 'Bilder, Audio, Video, Dokumente, Tabellen und Archive',
    applyFormatToAll: 'Format für alle Dateien',
    formatsByCategory: 'Formate nach Kategorie',
    fileFormat: 'Dateiformat',
    formatSearch: 'Format suchen',
    formatSearchPlaceholder: 'Zum Beispiel: webp, pdf, mp3',
    noFormatsFound: 'Keine Formate gefunden',
    chooseFormatAfterUpload: 'Zuerst Dateien hochladen',
    chooseFormatAfterUploadText: 'Nach dem Upload erhält jede Datei eine eigene durchsuchbare Formatauswahl.',
    chooseFormat: 'Format wählen',
    conversionQueue: 'Warteschlange',
    selectedFilesTitle: 'Dateien zum Konvertieren',
    selectedFilesText: 'Legen Sie Format und Kompression fest, bevor die Konvertierung startet.',
    estimatedSize: 'Geschätzte Größe',
    estimatedTotalSize: 'Geschätzt nach Verarbeitung',
    batchActions: 'Stapelaktionen',
    batchActionsText: 'Wenden Sie ein gemeinsames Format an, wenn alle Dateien denselben Typ haben, oder konfigurieren Sie jede Datei separat.',
    noCommonFormats: 'Die ausgewählten Dateien haben keine gemeinsame Formatauswahl. Konfigurieren Sie jede Dateikarte separat.',
    serverRequiredSelection: 'Ein oder mehrere gewählte Formate werden auf dem Server mit freien LibreOffice-, Ghostscript- oder ImageMagick-Engines verarbeitet.',
    removeFile: 'Datei entfernen',
    compressionSettings: 'Kompression',
    compressionLevel: 'Kompression {value}%',
    compressionHint: 'Höhere Kompression erzeugt kleinere Dateien, aber geringere Qualität bei Bildern, Audio, Video und GIF.',
    conversionProgress: 'Konvertierungsfortschritt',
    conversionProgressCurrent: 'Aktuell: {file}',
    conversionProgressDone: 'Konvertierung abgeschlossen',
    serverRequiredShort: 'Server nötig',
    serverRequiredDesc: 'Server-Konvertierung mit freien LibreOffice-, Ghostscript- oder ImageMagick-Engines.',
    'category.image': 'Bilder',
    'category.audio': 'Audio',
    'category.video': 'Video',
    'category.document': 'Dokumente',
    'category.data': 'Daten',
    'category.archive': 'Archive',
    footerText: 'Ein kostenloser Browserdienst für Bildbearbeitung und Stapelkonvertierung von Dateien ohne Wasserzeichen.',
    seoTitle: 'Basisoperationen in einer Oberfläche',
    seoText: 'Kim Converter verarbeitet Bilder, CSV, JSON und ZIP lokal im Browser.',
    light: 'Hell',
    dark: 'Dunkel',
  },
  el: {
    appName: 'Kim Converter',
    navTools: 'Εργαλεία',
    navSeo: 'Δυνατότητες',
    heroTitle: 'Γρήγορος μετατροπέας εικόνων και αρχείων',
    heroText: 'Αλλάξτε μέγεθος, περικόψτε και μετατρέψτε αρχεία απευθείας στο πρόγραμμα περιήγησης.',
    heroCta: 'Ξεκινήστε',
    heroPrivacy: 'Χωρίς αποστολή σε διακομιστή',
    imageTool: 'Εικόνες',
    fileTool: 'Αρχεία',
    uploadImage: 'Ανεβάστε εικόνα',
    uploadFile: 'Ανεβάστε αρχείο',
    dropImage: 'PNG, JPEG, WebP, AVIF ή BMP',
    chooseFile: 'Επιλογή αρχείου',
    resize: 'Μέγεθος',
    crop: 'Περικοπή',
    format: 'Μορφή',
    quality: 'Ποιότητα',
    width: 'Πλάτος',
    height: 'Ύψος',
    keepRatio: 'Διατήρηση αναλογιών',
    preset: 'Αναλογία',
    process: 'Επεξεργασία',
    download: 'Λήψη',
    convertedReady: 'Το αρχείο είναι έτοιμο',
    conversionType: 'Τύπος μετατροπής',
    jsonToCsv: 'JSON σε CSV',
    jsonToCsvDesc: 'Λίστα αντικειμένων σε πίνακα CSV',
    csvToJson: 'CSV σε JSON',
    csvToJsonDesc: 'Πίνακας CSV σε μορφοποιημένο JSON',
    textToZip: 'Αρχείο σε ZIP',
    textToZipDesc: 'Συμπίεση επιλεγμένου αρχείου σε ZIP',
    seoTitle: 'Βασικές λειτουργίες σε μία διεπαφή',
    seoText: 'Το Kim Converter επεξεργάζεται εικόνες, CSV, JSON και ZIP τοπικά στο πρόγραμμα περιήγησης.',
    light: 'Φωτεινό',
    dark: 'Σκοτεινό',
  },
  es: {
    appName: 'Kim Converter',
    navTools: 'Herramientas',
    navSeo: 'Funciones',
    heroTitle: 'Conversor rápido de imágenes y archivos',
    heroText: 'Redimensiona, recorta y convierte archivos directamente en el navegador.',
    heroCta: 'Empezar',
    heroPrivacy: 'Sin subida al servidor',
    imageTool: 'Imágenes',
    fileTool: 'Archivos',
    uploadImage: 'Subir imagen',
    uploadFile: 'Subir archivo',
    dropImage: 'PNG, JPEG, WebP, AVIF o BMP',
    chooseFile: 'Elegir archivo',
    resize: 'Tamaño',
    crop: 'Recorte',
    format: 'Formato',
    quality: 'Calidad',
    width: 'Ancho',
    height: 'Alto',
    keepRatio: 'Mantener proporción',
    preset: 'Proporción',
    process: 'Procesar',
    download: 'Descargar',
    convertedReady: 'Archivo listo',
    conversionType: 'Tipo de conversión',
    jsonToCsv: 'JSON a CSV',
    jsonToCsvDesc: 'Lista de objetos a tabla CSV',
    csvToJson: 'CSV a JSON',
    csvToJsonDesc: 'Tabla CSV a JSON formateado',
    textToZip: 'Archivo a ZIP',
    textToZipDesc: 'Comprime cualquier archivo seleccionado en ZIP',
    seoTitle: 'Operaciones básicas en una interfaz',
    seoText: 'Kim Converter procesa imágenes, CSV, JSON y ZIP localmente en el navegador.',
    light: 'Claro',
    dark: 'Oscuro',
  },
  fr: {
    appName: 'Kim Converter',
    navTools: 'Outils',
    navSeo: 'Fonctions',
    heroTitle: 'Convertisseur rapide d’images et de fichiers',
    heroText: 'Redimensionnez, recadrez et convertissez vos fichiers directement dans le navigateur.',
    heroCta: 'Commencer',
    heroPrivacy: 'Aucun envoi au serveur',
    imageTool: 'Images',
    fileTool: 'Fichiers',
    uploadImage: 'Importer une image',
    uploadFile: 'Importer un fichier',
    dropImage: 'PNG, JPEG, WebP, AVIF ou BMP',
    chooseFile: 'Choisir un fichier',
    resize: 'Taille',
    crop: 'Recadrage',
    format: 'Format',
    quality: 'Qualité',
    width: 'Largeur',
    height: 'Hauteur',
    keepRatio: 'Conserver les proportions',
    preset: 'Ratio',
    process: 'Traiter',
    download: 'Télécharger',
    convertedReady: 'Fichier prêt',
    conversionType: 'Type de conversion',
    jsonToCsv: 'JSON vers CSV',
    jsonToCsvDesc: 'Liste d’objets vers tableau CSV',
    csvToJson: 'CSV vers JSON',
    csvToJsonDesc: 'Table CSV vers JSON formaté',
    textToZip: 'Fichier vers ZIP',
    textToZipDesc: 'Compresser le fichier sélectionné en ZIP',
    seoTitle: 'Les opérations essentielles dans une seule interface',
    seoText: 'Kim Converter traite localement les images, CSV, JSON et ZIP dans le navigateur.',
    light: 'Clair',
    dark: 'Sombre',
  },
};

const additionalTranslations: Partial<Record<LanguageCode, Translation>> = {
  el: {
    navPrivacy: 'Απόρρητο',
    seoFormatsEyebrow: 'Μορφές και απόρρητο',
    seoFormatsTitle: 'Μετατροπή αρχείων χωρίς αποστολή σε διακομιστή',
    seoFormatsText: 'Το Kim Converter είναι φτιαγμένο για γρήγορες εργασίες: προετοιμασία εικόνας για site, αλλαγή μεγέθους φωτογραφίας, περικοπή κάδρου, μετατροπή JSON σε CSV ή συμπίεση αρχείου σε ZIP.',
    seoFormatsImage: 'Εικόνες: PNG, JPEG, AVIF, WebP και βασική αλλαγή μεγέθους ή περικοπή.',
    seoFormatsFiles: 'Αρχεία: μαζική μετατροπή εικόνων, JSON σε CSV, CSV σε JSON και δημιουργία ZIP.',
    seoFormatsPrivacy: 'Τα αρχεία επεξεργάζονται τοπικά στο πρόγραμμα περιήγησης και δεν αποστέλλονται στους διακομιστές Kim Converter.',
    popularConvertersEyebrow: 'Δημοφιλείς μετατροπείς',
    popularConvertersTitle: 'Μετατρέψτε αρχεία στη μορφή που χρειάζεστε',
    popularConvertersText: 'Σύρετε έγγραφο, ήχο, βίντεο, πίνακα ή αρχείο και η σελίδα θα ανοίξει τον μετατροπέα με τις διαθέσιμες μορφές.',
    privacyEyebrow: 'Δεδομένα και συγκατάθεση',
    privacyTitle: 'Πολιτική απορρήτου',
    privacyIntro: 'Το Kim Converter είναι εργαλείο προγράμματος περιήγησης: η κύρια επεξεργασία αρχείων γίνεται στη συσκευή σας. Αυτή η σελίδα εξηγεί ποια δεδομένα χρειάζεται ο ιστότοπος και πώς ενεργοποιούνται analytics και διαφήμιση.',
    privacyFilesTitle: 'Αρχεία και εικόνες',
    privacyFilesText: 'Τα αρχεία που επιλέγονται στη διεπαφή χρησιμοποιούνται για επεξεργασία μέσα στο πρόγραμμα περιήγησης. Ο ιστότοπος δεν τα ανεβάζει στους διακομιστές Kim Converter για μετατροπή, αποθήκευση ή έλεγχο.',
    privacyStorageTitle: 'Ρυθμίσεις ιστότοπου',
    privacyStorageText: 'Ο ιστότοπος θυμάται βασικές ρυθμίσεις ώστε η διεπαφή να λειτουργεί άνετα.',
    privacyAdsTitle: 'Analytics και διαφήμιση',
    privacyAdsText: 'Τα analytics βοηθούν στη βελτίωση του ιστότοπου. Η διαφήμιση χρησιμοποιείται μόνο με την άδειά σας.',
    privacyControlTitle: 'Έλεγχος συγκατάθεσης',
    privacyControlText: 'Μπορείτε να αλλάξετε την επιλογή σας σε αυτή τη σελίδα. Μετά την αποθήκευση ανανεώστε τη σελίδα για να εφαρμοστούν οι αλλαγές.',
    consentTitle: 'Cookies και απόρρητο',
    consentText: 'Χρησιμοποιούμε απαραίτητες ρυθμίσεις για να λειτουργεί ο ιστότοπος. Οι προαιρετικές κατηγορίες μπορούν να επιτραπούν ή να απενεργοποιηθούν ξεχωριστά.',
    consentAccept: 'Αποδοχή όλων',
    consentReject: 'Μόνο απαραίτητα',
    consentSettings: 'Ρυθμίσεις',
    consentBack: 'Πίσω',
    consentSave: 'Αποθήκευση επιλογής',
    consentSaveNotice: 'Η επιλογή σας αποθηκεύτηκε. Οι αλλαγές θα ισχύσουν μετά την ανανέωση της σελίδας.',
    consentNecessaryTitle: 'Απαραίτητα',
    consentNecessaryText: 'Χρειάζονται για τη λειτουργία του ιστότοπου και την αποθήκευση της επιλογής σας. Αυτή η κατηγορία δεν απενεργοποιείται.',
    consentAnalyticsTitle: 'Analytics',
    consentAnalyticsText: 'Βοηθούν να καταλάβουμε ποιες ενότητες και λειτουργίες χρησιμοποιούνται συχνότερα και πού εμφανίζονται σφάλματα.',
    consentAdvertisingTitle: 'Διαφήμιση',
    consentAdvertisingText: 'Χρειάζεται για προβολή διαφήμισης και αξιολόγηση της απόδοσής της, αν συνδεθεί διαφήμιση.',
    startWork: 'Ξεκινήστε εργασία',
    heroSecondaryCta: 'Γιατί είναι δωρεάν',
    taskChoiceEyebrow: 'Επιλέξτε εργασία',
    taskChoiceTitle: 'Τι θέλετε να κάνετε με το αρχείο;',
    taskChoiceText: 'Ανεβάστε αρχείο στην κατάλληλη στήλη ή ανοίξτε τη σελίδα του εργαλείου. Μετά την αποστολή το αρχείο μεταφέρεται στον σωστό χώρο εργασίας.',
    fileTaskBadge: 'Μετατροπή',
    imageTaskBadge: 'Επεξεργασία',
    fileInfoTitle: 'Μετατροπή αρχείων χωρίς επιπλέον βήματα',
    fileInfoText: 'Ανεβάστε αρχείο, επιλέξτε μορφή και κατεβάστε το αποτέλεσμα. Ο μετατροπέας λειτουργεί με εικόνες, πίνακες, έγγραφα, ήχο, βίντεο και ZIP.',
    fileInfoCta: 'Άνοιγμα μετατροπέα',
    fileInfoDetailsEyebrow: 'Μόνο μετατροπή',
    fileInfoDetailsTitle: 'Οι μορφές είναι σε μία ροή εργασίας',
    fileInfoDetailsText: 'Η σελίδα μετατροπής εστιάζει μόνο σε αρχεία: επιλογή μορφής, μαζική επεξεργασία, εκτίμηση μεγέθους και λήψη.',
    fileInfoPointOne: 'Υποστηρίζει εικόνες, ήχο, βίντεο, έγγραφα, JSON, CSV και ZIP.',
    fileInfoPointTwo: 'Επιλέξτε μορφή για κάθε αρχείο ή εφαρμόστε μία κοινή μορφή σε ομάδα.',
    fileInfoPointThree: 'Η επεξεργασία στο πρόγραμμα περιήγησης χρησιμοποιείται όπου είναι δυνατό· σύνθετες μορφές περνούν από τον διακομιστή.',
    imageInfoTitle: 'Επεξεργασία εικόνων στο πρόγραμμα περιήγησης',
    imageInfoText: 'Ανεβάστε εικόνα, αλλάξτε μέγεθος, περικόψτε, κρατήστε αναλογίες και εξαγάγετε σε PNG, JPEG, PNG ή AVIF.',
    imageInfoCta: 'Άνοιγμα επεξεργαστή',
    imageInfoDetailsEyebrow: 'Μόνο εικόνες',
    imageInfoDetailsTitle: 'Τα εργαλεία εικόνας είναι ξεχωριστά από τη μετατροπή αρχείων',
    imageInfoDetailsText: 'Η σελίδα εικόνων εστιάζει μόνο σε φωτογραφίες: προεπισκόπηση, περικοπή, διαστάσεις, ποιότητα και εξαγωγή.',
    imageInfoPointOne: 'Περικοπή με έτοιμες αναλογίες ή ελεύθερο πλαίσιο.',
    imageInfoPointTwo: 'Αλλαγή πλάτους και ύψους με διατήρηση αναλογιών.',
    imageInfoPointThree: 'Εξαγωγή σε PNG, JPEG, PNG ή AVIF χωρίς υδατογραφήματα.',
    conversionInput: 'Πηγή',
    conversionOutput: 'Αποτέλεσμα',
    conversionPrevious: 'Προηγούμενο ζεύγος μορφών',
    conversionNext: 'Επόμενο ζεύγος μορφών',
    conversionOpen: 'Άνοιγμα σελίδας μετατροπής για αυτό το ζεύγος',
    language: 'Γλώσσα',
    categoryTitle: 'Ανεβάστε φωτογραφία για επεξεργασία',
    categoryText: 'Σύρετε φωτογραφία, επιλέξτε από τη συσκευή ή επικολλήστε URL. Η εικόνα ανοίγει στον επεξεργαστή για περικοπή, αλλαγή μεγέθους και εξαγωγή.',
    homeImageUploadTitle: 'Σύρετε φωτογραφία για επεξεργασία',
    homeImageUploadText: 'PNG, JPG, AVIF, WebP, BMP, GIF ή SVG',
    homeConverterUploadTitle: 'Σύρετε αρχείο για μετατροπή',
    homeConverterUploadText: 'Εικόνες, ήχος, βίντεο, έγγραφα, πίνακες και αρχεία',
    homeUploadTitle: 'Σύρετε αρχείο εδώ',
    homeUploadText: 'Εικόνες, ήχος, βίντεο, έγγραφα, πίνακες και αρχεία',
    homeUploadUrlPlaceholder: 'Επικολλήστε URL αρχείου',
    homeUploadUrlButton: 'Άνοιγμα URL',
    homeUploadUrlError: 'Δεν ήταν δυνατή η φόρτωση από αυτό το URL. Ελέγξτε τον σύνδεσμο ή επιλέξτε τοπικό αρχείο.',
    imageCategoryTitle: 'Επεξεργασία εικόνων',
    imageCategoryText: 'Αλλάξτε μέγεθος, κρατήστε αναλογίες, επιλέξτε αναλογία πλευρών, περικόψτε και εξαγάγετε σε PNG, JPEG, PNG ή AVIF.',
    fileCategoryTitle: 'Μετατροπή αρχείων',
    fileCategoryText: 'Μετατρέψτε αρχεία από μία μορφή σε άλλη: εικόνες, πίνακες, JSON, CSV, ZIP και περισσότερες μορφές.',
    openCategory: 'Άνοιγμα σελίδας',
    backToCategories: 'Πίσω στις κατηγορίες',
    imagePageTitle: 'Επεξεργασία εικόνων',
    imagePageText: 'Ανεβάστε εικόνα, ορίστε περικοπή, μέγεθος, μορφή και ποιότητα. Κατεβάστε το αποτέλεσμα χωρίς υδατογράφημα.',
    filePageTitle: 'Μετατροπή αρχείων',
    filePageText: 'Επιλέξτε προφίλ μετατροπής, ανεβάστε αρχείο και λάβετε το αποτέλεσμα χωρίς ουρές ή όρια.',
    freeTitle: 'Δωρεάν για κάθε εργασία',
    freeText: 'Η επεξεργασία εικόνων και η μετατροπή αρχείων είναι διαθέσιμες χωρίς συνδρομές, δοκιμές ή πληρωμένες εξαγωγές.',
    watermarkTitle: 'Χωρίς υδατογραφήματα',
    watermarkText: 'Τα αρχεία που κατεβάζετε παραμένουν δικά σας: δεν προστίθενται λογότυπα, υπογραφές ή διαφημιστικές σημάνσεις.',
    unlimitedTitle: 'Απεριόριστη επεξεργασία',
    unlimitedText: 'Επεξεργαστείτε όσα αρχεία χρειάζεστε. Δεν υπάρχουν όρια ενεργειών μέσα στη διεπαφή.',
    uploadFiles: 'Ανεβάστε αρχεία',
    selectedFilesCount: 'Επιλεγμένα αρχεία: {count}',
    clearFiles: 'Καθαρισμός λίστας',
    convertedFilesReady: 'Έτοιμα αρχεία: {count}',
    downloadAll: 'Λήψη ZIP',
    fileUploadHint: 'Εικόνες, ήχος, βίντεο, έγγραφα, πίνακες και αρχεία',
    applyFormatToAll: 'Μορφή για όλα τα αρχεία',
    formatsByCategory: 'Μορφές ανά κατηγορία',
    fileFormat: 'Μορφή αρχείου',
    formatSearch: 'Αναζήτηση μορφής',
    formatSearchPlaceholder: 'Για παράδειγμα: webp, pdf, mp3',
    noFormatsFound: 'Δεν βρέθηκαν μορφές',
    chooseFormatAfterUpload: 'Ανεβάστε πρώτα αρχεία',
    chooseFormatAfterUploadText: 'Μετά την αποστολή, κάθε αρχείο αποκτά δικό του επιλογέα μορφής με αναζήτηση.',
    chooseFormat: 'Επιλέξτε μορφή',
    conversionQueue: 'Ουρά',
    selectedFilesTitle: 'Αρχεία για μετατροπή',
    selectedFilesText: 'Ορίστε μορφή και συμπίεση πριν ξεκινήσει η μετατροπή.',
    estimatedSize: 'Εκτιμώμενο μέγεθος',
    estimatedTotalSize: 'Εκτίμηση μετά την επεξεργασία',
    batchActions: 'Μαζικές ενέργειες',
    batchActionsText: 'Εφαρμόστε μία μορφή όταν όλα τα αρχεία έχουν ίδιο τύπο ή ρυθμίστε κάθε αρχείο ξεχωριστά.',
    noCommonFormats: 'Τα επιλεγμένα αρχεία δεν έχουν κοινό σύνολο μορφών. Ρυθμίστε κάθε κάρτα αρχείου ξεχωριστά.',
    serverRequiredSelection: 'Μία ή περισσότερες επιλεγμένες μορφές θα επεξεργαστούν στον διακομιστή με δωρεάν LibreOffice, Ghostscript ή ImageMagick.',
    removeFile: 'Αφαίρεση αρχείου',
    compressionSettings: 'Συμπίεση',
    compressionLevel: 'Συμπίεση {value}%',
    compressionHint: 'Μεγαλύτερη συμπίεση σημαίνει μικρότερα αρχεία αλλά χαμηλότερη ποιότητα για εικόνες, ήχο, βίντεο και GIF.',
    conversionProgress: 'Πρόοδος μετατροπής',
    conversionProgressCurrent: 'Τώρα: {file}',
    conversionProgressDone: 'Η μετατροπή ολοκληρώθηκε',
    serverRequiredShort: 'απαιτείται διακομιστής',
    serverRequiredDesc: 'Μετατροπή στον διακομιστή με δωρεάν LibreOffice, Ghostscript ή ImageMagick.',
    footerText: 'Δωρεάν υπηρεσία στο πρόγραμμα περιήγησης για επεξεργασία εικόνων και μαζική μετατροπή αρχείων χωρίς υδατογραφήματα.',
  },
  es: {
    navPrivacy: 'Privacidad',
    seoFormatsEyebrow: 'Formatos y privacidad',
    seoFormatsTitle: 'Conversión de archivos sin subir al servidor',
    seoFormatsText: 'Kim Converter está pensado para tareas rápidas: preparar una imagen para una web, cambiar el tamaño de una foto, recortar un encuadre, convertir tablas JSON a CSV o comprimir un archivo en ZIP.',
    seoFormatsImage: 'Imágenes: PNG, JPEG, AVIF, WebP y edición básica de tamaño o recorte.',
    seoFormatsFiles: 'Archivos: conversión por lotes de imágenes, JSON a CSV, CSV a JSON y empaquetado ZIP.',
    seoFormatsPrivacy: 'Los archivos se procesan localmente en el navegador; los archivos seleccionados no se suben a los servidores de Kim Converter.',
    popularConvertersEyebrow: 'Convertidores populares',
    popularConvertersTitle: 'Convierte archivos al formato que necesitas',
    popularConvertersText: 'Suelta un documento, audio, vídeo, tabla o archivo y el sitio abrirá el convertidor con los formatos disponibles.',
    privacyEyebrow: 'Datos y consentimiento',
    privacyTitle: 'Política de privacidad',
    privacyIntro: 'Kim Converter es una herramienta del navegador: el procesamiento principal ocurre en tu dispositivo. Esta página explica qué datos necesita el sitio y cómo se activan analítica y publicidad.',
    privacyFilesTitle: 'Archivos e imágenes',
    privacyFilesText: 'Los archivos seleccionados en la interfaz se usan para procesarse dentro del navegador. El sitio no los sube a servidores de Kim Converter para conversión, almacenamiento o revisión manual.',
    privacyStorageTitle: 'Ajustes del sitio',
    privacyStorageText: 'El sitio recuerda ajustes básicos para que la interfaz funcione cómodamente.',
    privacyAdsTitle: 'Analítica y publicidad',
    privacyAdsText: 'La analítica ayuda a mejorar el sitio. La publicidad se usa solo con tu permiso.',
    privacyControlTitle: 'Control del consentimiento',
    privacyControlText: 'Puedes cambiar tu elección en esta página. Después de guardar, actualiza la página para aplicar los cambios.',
    consentTitle: 'Cookies y privacidad',
    consentText: 'Usamos ajustes necesarios para que el sitio funcione. Las categorías opcionales se pueden permitir o desactivar por separado.',
    consentAccept: 'Aceptar todo',
    consentReject: 'Solo necesario',
    consentSettings: 'Ajustes',
    consentBack: 'Atrás',
    consentSave: 'Guardar elección',
    consentSaveNotice: 'Tu elección se ha guardado. Los cambios tendrán efecto después de actualizar la página.',
    consentNecessaryTitle: 'Necesario',
    consentNecessaryText: 'Necesario para que el sitio funcione y para guardar tu elección. Esta categoría no se puede desactivar.',
    consentAnalyticsTitle: 'Analítica',
    consentAnalyticsText: 'Ayuda a entender qué secciones y funciones se usan más y dónde aparecen errores.',
    consentAdvertisingTitle: 'Publicidad',
    consentAdvertisingText: 'Necesaria para mostrar publicidad y evaluar su rendimiento si la publicidad está conectada.',
    startWork: 'Empezar trabajo',
    heroSecondaryCta: 'Por qué es gratis',
    taskChoiceEyebrow: 'Elige una tarea',
    taskChoiceTitle: 'Qué necesitas hacer con el archivo',
    taskChoiceText: 'Sube un archivo en la columna adecuada o abre la página del instrumento. Después de subirlo, el sitio lo envía al espacio de trabajo correcto.',
    fileTaskBadge: 'Conversión',
    imageTaskBadge: 'Edición',
    fileInfoTitle: 'Conversión de archivos sin pasos extra',
    fileInfoText: 'Sube un archivo, elige el formato adecuado y descarga el resultado. El convertidor sirve para imágenes, tablas, documentos, audio, vídeo y ZIP.',
    fileInfoCta: 'Abrir convertidor',
    fileInfoDetailsEyebrow: 'Solo conversión',
    fileInfoDetailsTitle: 'Los formatos están reunidos en un flujo',
    fileInfoDetailsText: 'La página de conversión se centra solo en archivos: selección de formato, procesamiento por lotes, tamaño estimado y descarga.',
    fileInfoPointOne: 'Admite imágenes, audio, vídeo, documentos, JSON, CSV y ZIP.',
    fileInfoPointTwo: 'Elige un formato para cada archivo o aplica un formato común a un grupo.',
    fileInfoPointThree: 'Se usa procesamiento en navegador cuando es posible; los formatos complejos pasan por el convertidor del servidor.',
    imageInfoTitle: 'Edición de imágenes en el navegador',
    imageInfoText: 'Sube una imagen, cambia su tamaño, recorta, conserva proporciones y exporta el archivo final como PNG, JPEG, AVIF o WebP.',
    imageInfoCta: 'Abrir editor',
    imageInfoDetailsEyebrow: 'Solo imágenes',
    imageInfoDetailsTitle: 'Las herramientas de edición están separadas de la conversión de archivos',
    imageInfoDetailsText: 'La página de edición se centra solo en imágenes: vista previa, recorte, dimensiones, calidad y exportación.',
    imageInfoPointOne: 'Recorte con relaciones de aspecto preparadas o marco libre.',
    imageInfoPointTwo: 'Cambio de ancho y alto conservando proporciones.',
    imageInfoPointThree: 'Exportación a PNG, JPEG, AVIF o WebP sin marcas de agua.',
    conversionInput: 'Origen',
    conversionOutput: 'Resultado',
    conversionPrevious: 'Mostrar el par de formatos anterior',
    conversionNext: 'Mostrar el siguiente par de formatos',
    conversionOpen: 'Abrir la página de conversión de este par',
    language: 'Idioma',
    categoryTitle: 'Sube una foto para editar',
    categoryText: 'Suelta una foto, elígela desde el dispositivo o pega una URL. La imagen se abre en el editor para recortar, cambiar tamaño y exportar.',
    homeImageUploadTitle: 'Suelta una foto para editar',
    homeImageUploadText: 'PNG, JPG, AVIF, WebP, BMP, GIF o SVG',
    homeConverterUploadTitle: 'Suelta un archivo para convertir',
    homeConverterUploadText: 'Imágenes, audio, vídeo, documentos, tablas y archivos',
    homeUploadTitle: 'Suelta un archivo aquí',
    homeUploadText: 'Imágenes, audio, vídeo, documentos, tablas y archivos',
    homeUploadUrlPlaceholder: 'Pega una URL de archivo',
    homeUploadUrlButton: 'Abrir URL',
    homeUploadUrlError: 'No se pudo cargar el archivo desde esta URL. Comprueba el enlace o elige un archivo local.',
    imageCategoryTitle: 'Edición de imágenes',
    imageCategoryText: 'Cambia tamaño, conserva proporciones, elige relación de aspecto, recorta y exporta a PNG, JPEG, AVIF o WebP.',
    fileCategoryTitle: 'Conversión de archivos',
    fileCategoryText: 'Convierte archivos de un formato a otro: imágenes, tablas, JSON, CSV, ZIP y más formatos.',
    openCategory: 'Abrir página',
    backToCategories: 'Volver a categorías',
    imagePageTitle: 'Edición de imágenes',
    imagePageText: 'Sube una imagen, define recorte, tamaño, formato y calidad. Descarga el resultado sin marca de agua.',
    filePageTitle: 'Conversión de archivos',
    filePageText: 'Elige un perfil de conversión, sube un archivo y obtiene el resultado sin colas ni límites.',
    freeTitle: 'Gratis para cada tarea',
    freeText: 'La edición de imágenes y la conversión de archivos están disponibles sin suscripciones, pruebas ni exportaciones de pago.',
    watermarkTitle: 'Sin marcas de agua',
    watermarkText: 'Los archivos descargados siguen siendo tuyos: no se añaden logos, firmas ni marcas publicitarias.',
    unlimitedTitle: 'Procesamiento ilimitado',
    unlimitedText: 'Procesa tantos archivos como necesites. No hay límites de operaciones dentro de la interfaz.',
    uploadFiles: 'Subir archivos',
    selectedFilesCount: 'Archivos seleccionados: {count}',
    clearFiles: 'Limpiar lista',
    convertedFilesReady: 'Archivos listos: {count}',
    downloadAll: 'Descargar ZIP',
    fileUploadHint: 'Imágenes, audio, vídeo, documentos, tablas y archivos',
    applyFormatToAll: 'Formato para todos los archivos',
    formatsByCategory: 'Formatos por categoría',
    fileFormat: 'Formato de archivo',
    formatSearch: 'Buscar formato',
    formatSearchPlaceholder: 'Por ejemplo: webp, pdf, mp3',
    noFormatsFound: 'No se encontraron formatos',
    chooseFormatAfterUpload: 'Primero sube archivos',
    chooseFormatAfterUploadText: 'Después de subirlos, cada archivo tendrá su propio selector de formato con búsqueda.',
    chooseFormat: 'Elegir formato',
    conversionQueue: 'Cola',
    selectedFilesTitle: 'Archivos para convertir',
    selectedFilesText: 'Configura formato y compresión antes de iniciar la conversión.',
    estimatedSize: 'Tamaño estimado',
    estimatedTotalSize: 'Estimado después del procesamiento',
    batchActions: 'Acciones por lote',
    batchActionsText: 'Aplica un formato común cuando todos los archivos son del mismo tipo, o configura cada archivo por separado.',
    noCommonFormats: 'Los archivos seleccionados no comparten un conjunto común de formatos. Configura cada tarjeta por separado.',
    serverRequiredSelection: 'Uno o varios formatos seleccionados se procesarán en el servidor con motores gratuitos LibreOffice, Ghostscript o ImageMagick.',
    removeFile: 'Eliminar archivo',
    compressionSettings: 'Compresión',
    compressionLevel: 'Compresión {value}%',
    compressionHint: 'Más compresión produce archivos más pequeños, con menor calidad para imágenes, audio, vídeo y GIF.',
    conversionProgress: 'Progreso de conversión',
    conversionProgressCurrent: 'Ahora: {file}',
    conversionProgressDone: 'Conversión completa',
    serverRequiredShort: 'requiere servidor',
    serverRequiredDesc: 'Conversión en servidor con motores gratuitos LibreOffice, Ghostscript o ImageMagick.',
    footerText: 'Servicio gratuito en el navegador para editar imágenes y convertir archivos por lotes sin marcas de agua.',
  },
  fr: {
    navPrivacy: 'Confidentialité',
    seoFormatsEyebrow: 'Formats et confidentialité',
    seoFormatsTitle: 'Conversion de fichiers sans envoi au serveur',
    seoFormatsText: 'Kim Converter est conçu pour les tâches rapides: préparer une image pour un site, redimensionner une photo, recadrer, convertir des tableaux JSON en CSV ou compresser un fichier en ZIP.',
    seoFormatsImage: 'Images: PNG, JPEG, AVIF, WebP et édition simple de taille ou de recadrage.',
    seoFormatsFiles: 'Fichiers: conversion d’images par lot, JSON vers CSV, CSV vers JSON et création de ZIP.',
    seoFormatsPrivacy: 'Les fichiers sont traités localement dans le navigateur; les fichiers sélectionnés ne sont pas envoyés aux serveurs Kim Converter.',
    popularConvertersEyebrow: 'Convertisseurs populaires',
    popularConvertersTitle: 'Convertissez les fichiers au format nécessaire',
    popularConvertersText: 'Déposez un document, un audio, une vidéo, un tableau ou une archive; le site ouvrira le convertisseur avec les formats disponibles.',
    privacyEyebrow: 'Données et consentement',
    privacyTitle: 'Politique de confidentialité',
    privacyIntro: 'Kim Converter est un outil de navigateur: le traitement principal des fichiers se fait sur votre appareil. Cette page explique les données nécessaires et l’activation des analytics et de la publicité.',
    privacyFilesTitle: 'Fichiers et images',
    privacyFilesText: 'Les fichiers choisis dans l’interface sont utilisés pour le traitement dans le navigateur. Le site ne les envoie pas aux serveurs Kim Converter pour conversion, stockage ou vérification manuelle.',
    privacyStorageTitle: 'Réglages du site',
    privacyStorageText: 'Le site mémorise les réglages de base pour que l’interface fonctionne confortablement.',
    privacyAdsTitle: 'Analytics et publicité',
    privacyAdsText: 'Les analytics aident à améliorer le site. La publicité est utilisée uniquement avec votre autorisation.',
    privacyControlTitle: 'Contrôle du consentement',
    privacyControlText: 'Vous pouvez modifier votre choix sur cette page. Après l’enregistrement, actualisez la page pour appliquer les changements.',
    consentTitle: 'Cookies et confidentialité',
    consentText: 'Nous utilisons des réglages nécessaires au fonctionnement du site. Les catégories optionnelles peuvent être autorisées ou désactivées séparément.',
    consentAccept: 'Tout accepter',
    consentReject: 'Nécessaire seulement',
    consentSettings: 'Réglages',
    consentBack: 'Retour',
    consentSave: 'Enregistrer le choix',
    consentSaveNotice: 'Votre choix a été enregistré. Les changements prendront effet après l’actualisation de la page.',
    consentNecessaryTitle: 'Nécessaire',
    consentNecessaryText: 'Nécessaire au fonctionnement du site et à l’enregistrement de votre choix. Cette catégorie ne peut pas être désactivée.',
    consentAnalyticsTitle: 'Analytics',
    consentAnalyticsText: 'Aide à comprendre quelles sections et fonctions sont les plus utilisées et où des erreurs apparaissent.',
    consentAdvertisingTitle: 'Publicité',
    consentAdvertisingText: 'Nécessaire pour afficher de la publicité et évaluer ses performances si la publicité est connectée.',
    startWork: 'Commencer',
    heroSecondaryCta: 'Pourquoi gratuit',
    taskChoiceEyebrow: 'Choisissez une tâche',
    taskChoiceTitle: 'Que voulez-vous faire avec le fichier ?',
    taskChoiceText: 'Importez un fichier dans la colonne adaptée ou ouvrez la page dédiée. Après l’import, le site envoie le fichier dans le bon espace de travail.',
    fileTaskBadge: 'Conversion',
    imageTaskBadge: 'Édition',
    fileInfoTitle: 'Conversion de fichiers sans étapes inutiles',
    fileInfoText: 'Importez un fichier, choisissez le bon format et téléchargez le résultat. Le convertisseur fonctionne avec images, tableaux, documents, audio, vidéo et ZIP.',
    fileInfoCta: 'Ouvrir le convertisseur',
    fileInfoDetailsEyebrow: 'Conversion seulement',
    fileInfoDetailsTitle: 'Les formats sont réunis dans un seul flux',
    fileInfoDetailsText: 'La page de conversion se concentre sur les fichiers: choix du format, traitement par lot, estimation de taille et téléchargement.',
    fileInfoPointOne: 'Prend en charge images, audio, vidéo, documents, JSON, CSV et ZIP.',
    fileInfoPointTwo: 'Choisissez un format par fichier ou appliquez un format commun à un groupe.',
    fileInfoPointThree: 'Le traitement navigateur est utilisé quand c’est possible; les formats complexes passent par le convertisseur serveur.',
    imageInfoTitle: 'Édition d’images dans le navigateur',
    imageInfoText: 'Importez une image, redimensionnez-la, recadrez, gardez les proportions et exportez en PNG, JPEG, AVIF ou WebP.',
    imageInfoCta: 'Ouvrir l’éditeur',
    imageInfoDetailsEyebrow: 'Images seulement',
    imageInfoDetailsTitle: 'Les outils d’édition sont séparés de la conversion de fichiers',
    imageInfoDetailsText: 'La page d’édition se concentre sur les images: aperçu, recadrage, dimensions, qualité et export.',
    imageInfoPointOne: 'Recadrage avec ratios prêts ou cadre libre.',
    imageInfoPointTwo: 'Modification de largeur et hauteur en conservant les proportions.',
    imageInfoPointThree: 'Export en PNG, JPEG, AVIF ou WebP sans filigrane.',
    conversionInput: 'Source',
    conversionOutput: 'Résultat',
    conversionPrevious: 'Afficher la paire de formats précédente',
    conversionNext: 'Afficher la paire de formats suivante',
    conversionOpen: 'Ouvrir la page de conversion de cette paire',
    language: 'Langue',
    categoryTitle: 'Importez une photo à modifier',
    categoryText: 'Déposez une photo, choisissez-la sur votre appareil ou collez une URL. L’image s’ouvre dans l’éditeur pour recadrer, redimensionner et exporter.',
    homeImageUploadTitle: 'Déposez une photo à modifier',
    homeImageUploadText: 'PNG, JPG, AVIF, WebP, BMP, GIF ou SVG',
    homeConverterUploadTitle: 'Déposez un fichier à convertir',
    homeConverterUploadText: 'Images, audio, vidéo, documents, tableaux et archives',
    homeUploadTitle: 'Déposez un fichier ici',
    homeUploadText: 'Images, audio, vidéo, documents, tableaux et archives',
    homeUploadUrlPlaceholder: 'Collez une URL de fichier',
    homeUploadUrlButton: 'Ouvrir l’URL',
    homeUploadUrlError: 'Impossible de charger le fichier depuis cette URL. Vérifiez le lien ou choisissez un fichier local.',
    imageCategoryTitle: 'Édition d’images',
    imageCategoryText: 'Redimensionnez, gardez les proportions, choisissez un ratio, recadrez et exportez en PNG, JPEG, AVIF ou WebP.',
    fileCategoryTitle: 'Conversion de fichiers',
    fileCategoryText: 'Convertissez les fichiers d’un format à un autre: images, tableaux, JSON, CSV, ZIP et autres formats.',
    openCategory: 'Ouvrir la page',
    backToCategories: 'Retour aux catégories',
    imagePageTitle: 'Édition d’images',
    imagePageText: 'Importez une image, définissez recadrage, taille, format et qualité. Téléchargez le résultat sans filigrane.',
    filePageTitle: 'Conversion de fichiers',
    filePageText: 'Choisissez un profil de conversion, importez un fichier et obtenez le résultat sans file d’attente ni limite.',
    freeTitle: 'Gratuit pour chaque tâche',
    freeText: 'L’édition d’images et la conversion de fichiers sont disponibles sans abonnement, période d’essai ni export payant.',
    watermarkTitle: 'Sans filigrane',
    watermarkText: 'Les fichiers téléchargés restent à vous: aucun logo, signature ou marque publicitaire n’est ajouté.',
    unlimitedTitle: 'Traitement illimité',
    unlimitedText: 'Traitez autant de fichiers que nécessaire. Il n’y a pas de limite d’opérations dans l’interface.',
    uploadFiles: 'Importer des fichiers',
    selectedFilesCount: 'Fichiers sélectionnés: {count}',
    clearFiles: 'Vider la liste',
    convertedFilesReady: 'Fichiers prêts: {count}',
    downloadAll: 'Télécharger le ZIP',
    fileUploadHint: 'Images, audio, vidéo, documents, tableaux et archives',
    applyFormatToAll: 'Format pour tous les fichiers',
    formatsByCategory: 'Formats par catégorie',
    fileFormat: 'Format de fichier',
    formatSearch: 'Rechercher un format',
    formatSearchPlaceholder: 'Par exemple: webp, pdf, mp3',
    noFormatsFound: 'Aucun format trouvé',
    chooseFormatAfterUpload: 'Importez d’abord des fichiers',
    chooseFormatAfterUploadText: 'Après l’import, chaque fichier reçoit son propre sélecteur de format avec recherche.',
    chooseFormat: 'Choisir le format',
    conversionQueue: 'File',
    selectedFilesTitle: 'Fichiers à convertir',
    selectedFilesText: 'Définissez le format et la compression avant de lancer la conversion.',
    estimatedSize: 'Taille estimée',
    estimatedTotalSize: 'Estimation après traitement',
    batchActions: 'Actions par lot',
    batchActionsText: 'Appliquez un format commun lorsque les fichiers ont le même type, ou configurez chaque fichier séparément.',
    noCommonFormats: 'Les fichiers sélectionnés ne partagent pas le même ensemble de formats. Configurez chaque carte séparément.',
    serverRequiredSelection: 'Un ou plusieurs formats sélectionnés seront traités sur le serveur avec les moteurs gratuits LibreOffice, Ghostscript ou ImageMagick.',
    removeFile: 'Supprimer le fichier',
    compressionSettings: 'Compression',
    compressionLevel: 'Compression {value}%',
    compressionHint: 'Une compression plus élevée donne des fichiers plus petits, avec une qualité plus basse pour images, audio, vidéo et GIF.',
    conversionProgress: 'Progression de la conversion',
    conversionProgressCurrent: 'Maintenant: {file}',
    conversionProgressDone: 'Conversion terminée',
    serverRequiredShort: 'serveur requis',
    serverRequiredDesc: 'Conversion serveur avec les moteurs gratuits LibreOffice, Ghostscript ou ImageMagick.',
    footerText: 'Service gratuit dans le navigateur pour éditer des images et convertir des fichiers par lot sans filigrane.',
  },
};

const generatedProfileTranslations: Record<
  LanguageCode,
  {
    categories: Record<string, string>;
    imageTitle: (format: string) => string;
    imageDesc: (format: string) => string;
    audioTitle: (format: string) => string;
    audioDesc: (format: string) => string;
    videoTitle: (format: string) => string;
    videoDesc: (format: string) => string;
    documentTitle: (format: string) => string;
    docxToTxtDesc: string;
    txtToPdfTitle: string;
    txtToPdfDesc: string;
    txtToTextTitle: string;
    txtToTextDesc: string;
  }
> = {
  ru: {
    categories: {
      image: 'Изображения',
      audio: 'Аудио',
      video: 'Видео',
      document: 'Документы',
      data: 'Данные',
      archive: 'Архивы',
    },
    imageTitle: (format) => `Изображения в ${format}`,
    imageDesc: (format) => `Пакетная конвертация изображений в ${format}`,
    audioTitle: (format) => `Аудио в ${format}`,
    audioDesc: (format) => `Конвертация аудио в ${format}`,
    videoTitle: (format) => `Видео в ${format}`,
    videoDesc: (format) => `Конвертация видео в ${format}`,
    documentTitle: (format) => `Документы в ${format}`,
    docxToTxtDesc: 'Извлечение текста из DOCX локально в браузере',
    txtToPdfTitle: 'TXT/TEXT в PDF',
    txtToPdfDesc: 'Создание простого PDF из текстового файла',
    txtToTextTitle: 'TXT в TEXT',
    txtToTextDesc: 'Смена текстового расширения без изменения содержимого',
  },
  en: {
    categories: {
      image: 'Images',
      audio: 'Audio',
      video: 'Video',
      document: 'Documents',
      data: 'Data',
      archive: 'Archives',
    },
    imageTitle: (format) => `Images to ${format}`,
    imageDesc: (format) => `Batch image conversion to ${format}`,
    audioTitle: (format) => `Audio to ${format}`,
    audioDesc: (format) => `Convert audio to ${format}`,
    videoTitle: (format) => `Video to ${format}`,
    videoDesc: (format) => `Convert video to ${format}`,
    documentTitle: (format) => `Documents to ${format}`,
    docxToTxtDesc: 'Extract DOCX text locally in the browser',
    txtToPdfTitle: 'TXT/TEXT to PDF',
    txtToPdfDesc: 'Create a simple PDF from a text file',
    txtToTextTitle: 'TXT to TEXT',
    txtToTextDesc: 'Change the text extension without changing content',
  },
  de: {
    categories: {
      image: 'Bilder',
      audio: 'Audio',
      video: 'Video',
      document: 'Dokumente',
      data: 'Daten',
      archive: 'Archive',
    },
    imageTitle: (format) => `Bilder zu ${format}`,
    imageDesc: (format) => `Stapelkonvertierung von Bildern zu ${format}`,
    audioTitle: (format) => `Audio zu ${format}`,
    audioDesc: (format) => `Audio zu ${format} konvertieren`,
    videoTitle: (format) => `Video zu ${format}`,
    videoDesc: (format) => `Video zu ${format} konvertieren`,
    documentTitle: (format) => `Dokumente zu ${format}`,
    docxToTxtDesc: 'DOCX-Text lokal im Browser extrahieren',
    txtToPdfTitle: 'TXT/TEXT zu PDF',
    txtToPdfDesc: 'Ein einfaches PDF aus einer Textdatei erstellen',
    txtToTextTitle: 'TXT zu TEXT',
    txtToTextDesc: 'Texterweiterung ändern, ohne den Inhalt zu verändern',
  },
  el: {
    categories: {
      image: 'Εικόνες',
      audio: 'Ήχος',
      video: 'Βίντεο',
      document: 'Έγγραφα',
      data: 'Δεδομένα',
      archive: 'Αρχεία ZIP',
    },
    imageTitle: (format) => `Εικόνες σε ${format}`,
    imageDesc: (format) => `Μαζική μετατροπή εικόνων σε ${format}`,
    audioTitle: (format) => `Ήχος σε ${format}`,
    audioDesc: (format) => `Μετατροπή ήχου σε ${format}`,
    videoTitle: (format) => `Βίντεο σε ${format}`,
    videoDesc: (format) => `Μετατροπή βίντεο σε ${format}`,
    documentTitle: (format) => `Έγγραφα σε ${format}`,
    docxToTxtDesc: 'Εξαγωγή κειμένου DOCX τοπικά στο πρόγραμμα περιήγησης',
    txtToPdfTitle: 'TXT/TEXT σε PDF',
    txtToPdfDesc: 'Δημιουργία απλού PDF από αρχείο κειμένου',
    txtToTextTitle: 'TXT σε TEXT',
    txtToTextDesc: 'Αλλαγή επέκτασης κειμένου χωρίς αλλαγή περιεχομένου',
  },
  es: {
    categories: {
      image: 'Imágenes',
      audio: 'Audio',
      video: 'Vídeo',
      document: 'Documentos',
      data: 'Datos',
      archive: 'Archivos',
    },
    imageTitle: (format) => `Imágenes a ${format}`,
    imageDesc: (format) => `Conversión por lotes de imágenes a ${format}`,
    audioTitle: (format) => `Audio a ${format}`,
    audioDesc: (format) => `Convertir audio a ${format}`,
    videoTitle: (format) => `Vídeo a ${format}`,
    videoDesc: (format) => `Convertir vídeo a ${format}`,
    documentTitle: (format) => `Documentos a ${format}`,
    docxToTxtDesc: 'Extrae texto DOCX localmente en el navegador',
    txtToPdfTitle: 'TXT/TEXT a PDF',
    txtToPdfDesc: 'Crea un PDF simple desde un archivo de texto',
    txtToTextTitle: 'TXT a TEXT',
    txtToTextDesc: 'Cambia la extensión de texto sin cambiar el contenido',
  },
  fr: {
    categories: {
      image: 'Images',
      audio: 'Audio',
      video: 'Vidéo',
      document: 'Documents',
      data: 'Données',
      archive: 'Archives',
    },
    imageTitle: (format) => `Images vers ${format}`,
    imageDesc: (format) => `Conversion d'images par lot vers ${format}`,
    audioTitle: (format) => `Audio vers ${format}`,
    audioDesc: (format) => `Convertir l'audio vers ${format}`,
    videoTitle: (format) => `Vidéo vers ${format}`,
    videoDesc: (format) => `Convertir la vidéo vers ${format}`,
    documentTitle: (format) => `Documents vers ${format}`,
    docxToTxtDesc: 'Extraire le texte DOCX localement dans le navigateur',
    txtToPdfTitle: 'TXT/TEXT vers PDF',
    txtToPdfDesc: 'Créer un PDF simple à partir d’un fichier texte',
    txtToTextTitle: 'TXT vers TEXT',
    txtToTextDesc: 'Changer l’extension texte sans modifier le contenu',
  },
};

function translateGeneratedProfile(language: LanguageCode, key: string): string | null {
  const translations = generatedProfileTranslations[language];
  const categoryKey = /^category\.(image|audio|video|document|data|archive)$/.exec(key);
  if (categoryKey) {
    return translations.categories[categoryKey[1]];
  }

  const imageKey = /^imageTo([A-Z][A-Za-z0-9]+)(Desc)?$/.exec(key);
  if (imageKey) {
    const format = imageKey[1].toUpperCase();
    return imageKey[2] ? translations.imageDesc(format) : translations.imageTitle(format);
  }

  const audioKey = /^audioTo([A-Z][A-Za-z0-9]+)(Desc)?$/.exec(key);
  if (audioKey) {
    const format = audioKey[1].toUpperCase();
    return audioKey[2] ? translations.audioDesc(format) : translations.audioTitle(format);
  }

  const videoKey = /^videoTo([A-Z][A-Za-z0-9]+)(Desc)?$/.exec(key);
  if (videoKey) {
    const format = videoKey[1].toUpperCase();
    return videoKey[2] ? translations.videoDesc(format) : translations.videoTitle(format);
  }

  const documentKey = /^documentTo([A-Z][A-Za-z0-9]+)$/.exec(key);
  if (documentKey) {
    return translations.documentTitle(documentKey[1].toUpperCase());
  }

  if (key === 'docxToTxt') {
    return translations.documentTitle('TXT').replace(/^Documents?|^Dokumente|^Έγγραφα|^Documentos/, 'DOCX');
  }

  if (key === 'docxToTxtDesc') {
    return translations.docxToTxtDesc;
  }

  if (key === 'txtToPdf') {
    return translations.txtToPdfTitle;
  }

  if (key === 'txtToPdfDesc') {
    return translations.txtToPdfDesc;
  }

  if (key === 'txtToText') {
    return translations.txtToTextTitle;
  }

  if (key === 'txtToTextDesc') {
    return translations.txtToTextDesc;
  }

  return null;
}

export const translate = (language: LanguageCode, key: string): string =>
  dictionary[language][key] ?? additionalTranslations[language]?.[key] ?? translateGeneratedProfile(language, key) ?? dictionary.en[key] ?? key;
